var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.GenericCard,{attrs:{"color":"white","to":{
        name: 'address-all',
        params: {
            filters: { statusFilter: 'requested', webformFilter: false, initialQuery: '' },
        },
    }}},[_c('v-card-text',[_c('p',{staticClass:"card-title"},[_c('KpIcon',{attrs:{"icon-cls":"world","color":"black"}}),_vm._v(" "+_vm._s(_vm.$t('neuanmeldungen_kulturplatz'))+" "),_c('v-chip',{attrs:{"small":""}},[_vm._v(_vm._s(_setup.counter))])],1),_c('p',[_c('KpIcon',{attrs:{"icon-cls":"arrow-bigright","color":"grey"}}),_vm._v(" "+_vm._s(_vm.$t('to_new_kulturplatz'))+" ")],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }